export const NOTIFICATION_TYPE_CATEGORY_LABELS = {
    INVENTORY: "Inventory",
    UTILITIES: "Utilities",
    EMAILS: "Purchasing",
    AP_PAYMENTS: "Finance",
    RENEWALS: "Renewals",
};

export const notificationTypeCategoryLabel = (category) =>
    NOTIFICATION_TYPE_CATEGORY_LABELS[category] || category || "";

export const NOTIFICATION_TYPE_STATUSES = {
    active: "Active",
    paused: "Paused",
};

export const notificationTypeStatusLabel = (status) =>
    NOTIFICATION_TYPE_STATUSES[status] || status || "";

export const isValidEmailAddress = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
